var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { dropdownItemsNoTBDFull } from '@hn-front/data-types';
export var GRADES = dropdownItemsNoTBDFull.map(function (item) { return item.text; });
export var GRADES_WITH_GRADE_6 = __spreadArray(__spreadArray([], GRADES, true), ['Grade 6'], false);
export var TBD_GRADE = 'Grade level TBD';
export var GRADES_WITH_TBD = __spreadArray(__spreadArray([], GRADES, true), [TBD_GRADE], false);
